<template lang="pug">
div
  div(
    v-if="cadastrante.pessoa.pessoaFisica && cadastrante.pessoa.pessoaFisica.cpf",
    key="pessoaFisica"
  )
    el-row.labelDiv
      el-col.inputDiv(:span="12")
        app-display(
          label="Nome:",
          :content="cadastrante.pessoa.pessoaFisica.nome"
          v-if="cadastrante.pessoa.pessoaFisica.nome"
          :class = "compararCadastrante && compararCadastrante.mudouPessoa && compararCadastrante.mudouPessoa.mudouNome ? 'text': '' "
        )
      el-col.inputDiv(:span="12")
        app-display(
          label="CPF:",
          :content="cadastrante.pessoa.pessoaFisica.cpf",
          v-if="cadastrante.pessoa.pessoaFisica.cpf"
          :class = "compararCadastrante && compararCadastrante.mudouPessoa && compararCadastrante.mudouPessoa.mudouCPF ? 'text': '' "
        )
  div(
    v-if="cadastrante.pessoa.pessoaJuridica && cadastrante.pessoa.pessoaJuridica.cnpj"
    )
    el-row.labelDiv
      el-col.inputDiv(:span="12")
        app-display(
          label="CNPJ:",
          :content="cadastrante.pessoa.pessoaJuridica.cnpj",
          v-if="cadastrante.pessoa.pessoaJuridica.cnpj"
          :class = "compararCadastrante && compararCadastrante.mudouPessoa && compararCadastrante.mudouPessoa.mudouCNPJ ? 'text': '' "
        )
      el-col.inputDiv(:span="12")
        app-display(
          label="Razão Social:",
          :content="cadastrante.pessoa.pessoaJuridica.razaoSocial",
          v-if="cadastrante.pessoa.pessoaJuridica.razaoSocial"
          :class = "compararCadastrante && compararCadastrante.mudouPessoa && compararCadastrante.mudouPessoa.mudouRazaoSocial ? 'text': '' "
        )
  el-row
    el-col
      app-divider(label="Endereço")
        informacoes-endereco.margin-top(:endereco="enderecoCadastrante", slot="body", :mudouEndereco="compararCadastrante && compararCadastrante.mudouEndereco")

</template>

<script>
import AppDivider from '@/components/AppDivider'
import AppDisplay from '@/components/AppDisplay'
import moment from 'moment'
import InformacoesEndereco from '@/components/informacoesCadastro/common/InformacoesEndereco'

export default {
  props: {
    cadastrante: {
      type: Object,
      required: true
    },
    compararCadastrante: {
      type: Object,
      required: false
    }
  },

  components: {
    AppDisplay,
    InformacoesEndereco,
    AppDivider
  },

  computed: {
    enderecoCadastrante () {
      return this.cadastrante.pessoa.endereco ? this.cadastrante.pessoa.endereco : {}
    },

    data () {
      if (this.cadastrante.pessoa.pessoaFisica.dataNascimento) {
        return moment(this.cadastrante.pessoa.pessoaFisica.dataNascimento).format('DD/MM/YYYY')
      }
    },

    estadoCivilFormatado () {
      switch (this.cadastrante.pessoa.pessoaFisica.estadoCivil) {
        case 'SOLTEIRO':
          return 'Solteiro(a)'
        case 'CASADO':
          return 'Casado(a)'
        case 'DIVORCIADO':
          return 'Divorciado(a)'
        case 'SEPARADO':
          return 'Separado(a)'
        case 'VIUVO':
          return 'Viúvo(a)'
        case 'UNIAO_ESTAVEL':
          return 'União Estável'
        case 'UNIAO_HOMOAFETIVA':
          return 'União Homoafetiva'
      }
    }
  },

  methods: {
    getTelefones () {
      if (this.cadastrante.pessoa.telefones) {
        let phones = ''
        this.cadastrante.pessoa.telefones.forEach(element => {
          phones = phones + ' ' + element
        })
        return phones
      }
    }
  }

}
</script>

<style lang="scss" scoped>
  .margin-top {
    margin-top: 10px;
  }
  >>> .text .text{
    color: #ff0000 !important;
  }

  @media (max-width: 780px) {
    .labelDiv {
      display: flex;
      flex-direction: column;
    }

    .inputDiv {
      width: 85%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/cadastrosOnline/InformacoesCadastrante.vue